// extracted by mini-css-extract-plugin
export default {"simple-table":"LinkfarmProductResellForm_simple-table__ueX+Y"};